module.exports = __webpack_public_path__ + "img/fa-regular-400.2788556a.svg";